export default function(address:string[]){
  let data:{code:string,name:string}[] = [];
  address.map((v,index)=>{
    const item = v.split('_')
    data[index] = {code: item[0],name:item[1]}
  })
  return data
}